export function initStickyHeader() {
  const header = document.querySelector( '.ul-site-header' );

  if ( ! header ) return;

  const SCROLL_THRESHOLD = 10;

  window.addEventListener( 'scroll', () => {
    header.classList.toggle( 'is-scrolled', window.scrollY > SCROLL_THRESHOLD );
  }, { passive: true } );
}
